class OrganizationRole {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      organizationRoleId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allOrganizationRoles.length; i++) {
          if (this.allOrganizationRoles[i].id == 0) {
            return;
          }
        }
        this.allOrganizationRoles.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allOrganizationRoles;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allOrganizationRoles = [];
        this.allOrganizationRoles = temp;
        this.getOrganizationRoleFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.organizationRole = new OrganizationRole('');
      for (var i = 0; i < this.allOrganizationRoles.length; i++) {
        if (this.allOrganizationRoles[i].id == id) {
          if (id == 0) {
            this.allOrganizationRoles.splice(i, 1);
          }
          this.allOrganizationRoles[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addOrganizationRoleFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش سمت';
        this.$refs.confirm.text = 'از ویرایش سمت اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف سمت';
        this.$refs.confirm.text = 'از حذف سمت اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addOrganizationRoleFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editOrganizationRoleFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteOrganizationRoleFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.organizationRoleId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
